// --------------------------------------------------------------
// Created On: 2021-10-27
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import styles from "./NavigationDrawerLink.module.scss";
import SearchModal from "../../../pages/DashboardGeneralPage/SearchModal/SearchModal";

// A single selectable page link.
export default function NavigationDrawerLink(props: Props): Component {
  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const location = useLocation();

  function openSearchModal(): void {
    setShowSearchModal(true);
    props.onClick();
  }

  return (
    <Fragment>
      {props.name === "Order" ? (
        <Fragment>
          <div className={styles.body}>
            <div
              data-test="nav-drawer-link"
              className={`${styles.button} p-3 ${props.targetPage === location.pathname ? styles.selected : ""}`}
              onClick={() => openSearchModal()}
            >
              {props.name}
            </div>
          </div>
          <SearchModal showModal={showSearchModal} onClose={() => setShowSearchModal(false)} />
        </Fragment>
      ) : (
        <Link className={styles.body} to={props.targetPage} onClick={() => props.onClick()}>
          <div
            data-test="nav-drawer-link"
            className={`${styles.link} p-3 ${props.targetPage === location.pathname ? styles.selected : ""}`}
          >
            {props.name}
          </div>
        </Link>
      )}
    </Fragment>
  );
}

interface Props {
  name: string;
  targetPage: string;
  onClick: () => void;
}
